import { render, staticRenderFns } from "./BaseDragVerify.vue?vue&type=template&id=02987878"
import script from "./BaseDragVerify.vue?vue&type=script&lang=js"
export * from "./BaseDragVerify.vue?vue&type=script&lang=js"
import style0 from "./BaseDragVerify.vue?vue&type=style&index=0&id=02987878&prod&lang=scss&rel=text%2Fcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports